import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import * as environmentUrl from "../../../environments/environment";
import {RpcClientService} from "../../service/rpc-client.service";
import {Subscription} from "rxjs";
import { error } from 'console';


@Component({
  selector: 'app-identify-failure',
  templateUrl: './identify-failure.component.html',
  styleUrls: ['./identify-failure.component.scss']
})
export class IdentifyFailureComponent implements OnInit {
  public onList: boolean = false;
  public disabledcomponent: boolean = true;
  public disabledselectbutton: boolean = true;
  public disabledSection: boolean = true;
  public changeSectionList: boolean = false;
  public flagsection: boolean = false;
  public setAllCompname: boolean = true;
  public showSuggest: boolean = false;
  public filter: boolean = false;
  public firstPage: boolean = true;
  public secondPage: boolean = true;
  public isChecked: boolean = false;
  public disableCheckFinis: boolean = false
  public disableLabor: boolean = false
  public colorflag: boolean = false;
  public usertypeflag: boolean = false;
  public finisCodeVerify: boolean = false;
  public secheck: boolean = false;
  public cocheck: boolean = false;
  public lengthofcommenterror: any;
  public vinNumber: any;
  public groupSearch: any = [];
  public componentSearch: any = [];
  public allComponentSearch: any = [];
  public componentSearchAll: any = {};
  public sectionArray: any = [];
  public sectionArrayvalues: any = [];
  public secIndex: any;
  public sectionNameRecieved = '';
  public manualData: any;
  public groupName: any = '';
  public groupnamereq: any = '';
  public sectionName = '';
  public sectionnamereq: any = '';
  public componentName: any = '';
  public compnamereq: any = '';
  public allComponentName: any = '';
  public allComponentHidden: any = '';
  public tokenObj: any;
  public edit: any;
  public finis: any;
  public causeRepair: any;
  public errorMessage: any;
  public errorMsg: any;
  public count = 2000;
  public numcolor: any;
  public myText: any;
  public wordCount: any;
  public userType: any;
  public comparenames: any;
  public counting: any;
  public sectionNameHolder: any;
  public infotab: boolean = false;
  public hintstab: boolean = false;
  public submittab: boolean = false;
  public filteredGroupList: any;
  public sessionId: any;
  public userId: any;
  public compid: any;
  public index: any;
  public indexall: any;
  public componentId: any;
  public componentAllId: any;
  public allSearchId: any;
  public groupOthers: boolean = false;
  public sectionOthers: boolean = false;
  public componentOthers: boolean = false;
  showSBDAdminTab: boolean = false;
  resume = false;
  sId: any;
  pageData: any;
  vin: any
  dealerCode: any
  countrythree: any
  modelYear: any
  username: any
  vindetails: any
  vehicle: any
  language: any
  country: any
  info: any;
  isConfirBtnVisuallyDisabled: boolean = false;
  showRvcInput: boolean = false;
  showSpinner: boolean = false;
  selectedGroupID: any = '';
  selectedSectionID: any = '';
  @ViewChild('faultMsgInfo') faultMsgInfo: ElementRef | undefined;
  @ViewChild('noRVCMsgInfo') noRVCMsgInfo: ElementRef;
  @ViewChild('data') data:ElementRef;
  @ViewChild('InvalidRvcTemplate') InvalidRvcTemplate: ElementRef | undefined;
  isButtonEnabled: boolean = true;
  isComponentSearchDisabled: boolean = false;
  selectedSectionName: string = '';
  gtacpackagesub: Subscription = new Subscription;
  edmMarkets: any = ['AL', 'AM', 'AZ', 'BA', 'BY', 'BG', 'HR', 'CY', 'EE', 'FK', 'GI', 'GE', 'GS', 'KZ', 'LV', 'LT', 'MT', 'MD', 'MK', 'CS', , 'UA', 'TR', 'SI', 'SK', 'CS']
  private tokenDetails: any;
  private lang: string;
  isDSSHRestrictedModule: boolean;
 // private data: any;
    rvcCode: string = '';
    validationError: string = '';
    private sessionSource: any;
    private timeStamps: any;
    repairData: any;

  constructor(private service: ApifirstService, private router: Router, private translate: TranslateService, private modalService: NgbModal, private spinnerService: NgxSpinnerService, private rpcClientService: RpcClientService) {
  }

  ngOnInit(): void {
    this.info = this.translate.instant('NoRVCInfo') + ":" + "  "
      + "1." + " " + this.translate.instant('Rule1') + "  "
      + "2." + " " + this.translate.instant('Rule2') + "  "
      + "3." + " " + this.translate.instant('Rule3') + "  "
      + "4." + " " + this.translate.instant('Rule4') + "  "
      + "." + " " + this.translate.instant('NoRVCInfo1');

      this.isDSSHRestrictedModule = false;
      let pageID = "21";

      if(localStorage.getItem("isRVCINput") != undefined &&
         localStorage.getItem("isRVCINput") != '' &&
         localStorage.getItem("isRVCINput") != null &&
         localStorage.getItem("isRVCINput") == 'true' )
      {
          pageID = "25";
          this.firstPage = false;
          this.showRvcInput = true;
          this.isDSSHRestrictedModule = true;
          this.service.repairQualificationData.subscribe(data =>{
            console.log('IN IDENTITY PAGE:::::::::::::::::::', data)
            this.repairData = data;
            this.edit = this.repairData != null ? this.repairData.componentName : '';
          })
      }
      localStorage.removeItem("isRVCINput");
    //update page number
    const req = {
      "sessionId": localStorage.getItem("sessionID"),
      "pageid": pageID
    }
    this.service.updatePage(req).subscribe(data => { })
    this.service.tokenObj.subscribe((data) => {
      this.tokenObj = data
      this.userType = this.tokenObj.userType
      let c: any
      c = data
      this.language = c.language
      this.country = c.country
      this.dealerCode = c.dealerCode
      this.countrythree = c.countryThree
      this.vin = c.vin
      this.username = c.username
      this.service.showSBDAdminTab.subscribe((data) => {
        this.showSBDAdminTab = data
      })
      if (this.userType == "FORD_INTERNAL" || this.showSBDAdminTab == true) {
        this.usertypeflag = false
      }
      else {
        this.usertypeflag = true
      }
    })
    this.vinNumber = this.tokenObj.vin
    this.service.identifyDetails.subscribe((data) => {
      this.groupSearch = []
      this.manualData = data
      let toFetchGroupData = []
      toFetchGroupData = Object.keys(this.manualData.allComponentList ? this.manualData.allComponentList : {});
      this.componentSearchAll = toFetchGroupData
      this.allSearchId = Object.values(this.manualData.allComponentList ? this.manualData.allComponentList : {});
      this.groupSearch = this.manualData.groupList ? this.manualData.groupList : [];
      if (!(this.groupSearch.includes(this.translate.instant('Other not on list')))) {
        this.groupSearch.push(this.translate.instant('Other not on list'))
      }
      this.groupName = "default"
      this.sectionName = "default"
      this.componentName = "default"
      this.allComponentName = ''
      this.sectionNameHolder = "default"
    })
    this.sessionId = localStorage.getItem("sessionID");
    this.service.userId.subscribe((data) => {
      this.userId = data
    })
    //resume
    this.service.fromResume.subscribe(data => this.resume = data)
    if (this.resume) {
      this.service.sId.subscribe(data => {
        this.sId = data;
        const identifyObj = {
          "vin": this.vinNumber,
          "filtered": "true",
          "diagnostic": "true",
          "userId": this.userId,
          "userType": this.tokenObj.userType,
          "languageCode": this.tokenObj.language,
          "countryCode": this.tokenObj.countryThree,
          "sessionId": this.sessionId
        }
        this.service.getIdentifydetails(identifyObj).subscribe((data) => {
          this.service.identifyDetails.next(data)
          this.service.identifyDetails.subscribe((data) => {
            this.groupSearch = []
            this.manualData = data
            let toFetchGroupData = []
            toFetchGroupData = Object.keys(this.manualData.allComponentList)
            this.componentSearchAll = toFetchGroupData
            this.allSearchId = Object.values(this.manualData.allComponentList)
            this.groupSearch = this.manualData.groupList
            if (!(this.groupSearch.includes(this.translate.instant('Other not on list')))) {
              this.groupSearch.push(this.translate.instant('Other not on list'))
            }
            this.groupName = "default"
            this.sectionName = "default"
            this.componentName = "default"
            this.allComponentName = ''
            this.sectionNameHolder = "default"
          })
        })
      })
      this.service.fromResume.next(false);
    }
  }
  /* to select group*/
  onSelectgroup(setGroupname: any, value: number) {
    //Find Index for others not on list
    let index:number = this.groupSearch.findIndex((data: any) => {
      return data == setGroupname
    })
    if(index+1 == this.groupSearch.length) {
      this.groupOthers = true;
      this.isComponentSearchDisabled = false;
    } else {
      this.groupOthers = false;
      if(setGroupname != "default") {
        this.isComponentSearchDisabled = true;
      } else {
        this.isComponentSearchDisabled = false;
      }
    }
    console.log("Index",index,"lemgth:",this.groupSearch.length, "Others:",this.groupOthers);
    console.log('************Group Selection-----------------', setGroupname);
    this.selectedGroupID = this.extractNumbers(setGroupname);
    this.disabledselectbutton = true;
    this.groupName = setGroupname;
    this.disabledSection = true;
    this.secheck = false;
    if (value == 1) {
      this.disabledcomponent = true;
      this.componentName = "default";
      this.sectionName = "default";
    }
    if (this.groupName == "default") {
      this.disabledSection = true;
      this.disabledcomponent = true;
      this.componentName = "default";
      this.sectionName = "default";
    } else {
      if ((this.groupName == (this.translate.instant('Other not on list'))) || this.groupOthers) {
        console.log('************* Inside Others-----------------------');
        this.secheck = true;
        this.cocheck = true;
        if (value == 1) {
          this.disabledcomponent = true;
          this.componentName = "default";
        }
        this.flagsection = true;
        this.sectionName = "flagsection";
        this.sectionNameRecieved = "flagsection";
        this.componentName = "flagsection";
        this.compid = "0";
        this.componentId = "0";
        this.disabledcomponent = false;
        this.disabledselectbutton = false;
        this.allComponentName = '';
        this.sectionNameHolder = "default";
      } else {
        console.log('************* Outside Others-----------------------');
        this.secheck = false;
        this.cocheck = false;
        this.allComponentName = '';
        this.flagsection = false;
        if (this.groupName == ((this.translate.instant('Other not on list'))) || this.groupOthers) { this.groupnamereq = "0" } else { this.groupnamereq = this.groupName }
        if (this.sectionName == "flagsection") { this.sectionnamereq = "0" } else { this.sectionnamereq = this.sectionName }
        let req = {
          "userType": this.userType,
          "language": this.language,
          "countryCode": this.countrythree,
          "vin": this.vin,
          "userId": this.userId,
          "sessionid": parseInt(this.sessionId),
          "group": this.groupnamereq,
          "section": "",
          "component": "",
          "componentSearch": "",
          "pageState": "filterSection",
          "failureComments": "",
          "labourOnly": "",
          "finisCode": "",
          "filtered": "true",
          "diagnostic": "true"
        }
        this.service.getSectionList(req).subscribe((data) => {
          this.disabledSection = false;
          if (this.changeSectionList == true) {
            this.sectionNameHolder = this.sectionName;
            if (this.sectionNameHolder == "flagsection") {
              this.sectionNameHolder = "default";
              this.disabledcomponent = true;
              this.componentName = "default";
            }
            this.sectionArray = [];
            let filteredArray = [];
            this.sectionArray = data.sectionQualifierList;
            this.sectionArray.push(this.translate.instant('Other not on list'));
            this.comparenames = this.sectionName.substring(0, 6);
            for (let i of this.sectionArray) {
              if (i.substring(0, 6) == this.comparenames) {
                filteredArray.push(i);
              }
            }
            let str = filteredArray[1];
            if (filteredArray.length == 1) {
              str = filteredArray[0];
            }
            this.sectionName = str;
            this.allComponentName = '';
            if (this.componentName == "default") {
              this.disabledselectbutton = true;
            }
            else {
              this.disabledselectbutton = false;
            }
            if (this.sectionName == "flagsection") {
              this.sectionName = "default";
            }
            if (this.sectionNameHolder == "default" || this.sectionName == "default") {
              this.sectionName = "default";
            }
          } else if (!this.changeSectionList) {
            this.sectionArray = [];
            this.sectionArray = Object.keys(data.sectionList);
            this.sectionArrayvalues = Object.values(data.sectionList);
            this.sectionArray.push(this.translate.instant('Other not on list'));
            if (this.sectionName == "flagsection") {
              this.sectionName = "default";
            } else {
              this.sectionName = this.sectionNameHolder;
              this.sectionNameHolder = "default"
            }
            this.allComponentName = '';
            if (this.sectionNameHolder == "flagsection") {
              this.sectionNameHolder = "default";
              this.disabledcomponent = true;
              this.componentName = "default"
            }
            if (this.componentName == "default") {
              this.disabledselectbutton = true;
            }
            else {
              this.disabledselectbutton = false;
            }
            if (this.sectionName == "flagsection") {
              this.disabledcomponent = true
            }
          }
        },
          (err) => {
            /* if we get the response as error */
            this.componentName = "default"
            this.sectionName = "default"
            this.disabledcomponent = true
            this.disabledSection = true
            this.disabledselectbutton = true
          })
      }
    }
    if (this.allComponentName) {
      this.disabledselectbutton = false;
    }
  }

  /* to select section*/
  onSelectSection(setSectionname: any) {
    let index: number = this.sectionArray.findIndex((data: any) => {
      return data == setSectionname
    })
    this.selectedSectionName = setSectionname;
    if (index + 1 == this.sectionArray.length) {
      this.sectionOthers = true;
      this.isComponentSearchDisabled = false;
    } else {
      this.sectionOthers = false;
      if ((setSectionname != 'default') || (setSectionname == 'default' && this.groupName != 'default')) {
        this.isComponentSearchDisabled = true;
      } else {
        this.isComponentSearchDisabled = false;
      }
    }
    console.log("Index", index, "lemgth:", this.sectionArray.length, "Others:", this.sectionOthers);
    this.selectedSectionID = this.extractNumbers(setSectionname);
    this.disabledselectbutton = true;
    this.disabledcomponent = true
    if (this.sectionName != "flagsection") {
      this.componentName = "default"
    }
    if (setSectionname == "default") {
      this.disabledcomponent = true;
      this.componentName = "default";
    } else {
      if (this.groupName == ((this.translate.instant('Other not on list'))) || this.groupOthers) {
        this.secheck = true;
        this.cocheck = true;
        this.compid = "0";
        this.componentId = "0";
        if (this.sectionName == "default") {
          this.disabledcomponent = true;
          this.disabledselectbutton = true;
          this.componentName = "default";
        } else {
          this.sectionName = "flagsection";
          this.sectionNameRecieved = "flagsection";
          this.disabledcomponent = false;
          this.disabledselectbutton = false;
          this.componentName = "flagsection";
        }
        this.flagsection = true;
        this.allComponentName = '';
      } else {
        this.secheck = false;
        this.cocheck = false;
        this.flagsection = false;
        this.secIndex = this.sectionArray.findIndex((data: any) => {
          return data == setSectionname
        })
        this.disabledselectbutton = true;
        this.allComponentName = '';
        if (this.changeSectionList) {
          if (setSectionname == ((this.translate.instant('Other not on list')) || this.sectionOthers)) {
            this.sectionNameRecieved = "flagsection"
            this.componentName = "flagsection";
            this.disabledselectbutton = false;
            this.flagsection = true;
          } else {
            this.sectionNameRecieved = setSectionname;
          }
        } else {
          if (setSectionname == ((this.translate.instant('Other not on list')) || this.sectionOthers)) {
            this.sectionNameRecieved = "flagsection"
            this.componentName = "flagsection";
            this.disabledselectbutton = false;
            this.flagsection = true;
          } else {
            this.sectionNameRecieved = this.sectionArrayvalues[this.secIndex]
          }
        }
        if (this.groupName == ((this.translate.instant('Other not on list')) || this.groupOthers)) {
          this.groupnamereq = "0"
        } else {
          this.groupnamereq = this.groupName
        }
        if (this.sectionNameRecieved == "flagsection") {
          this.sectionnamereq = "0"
        } else {
          this.sectionnamereq = this.sectionNameRecieved
        }
        let req = {
          "userType": this.userType,
          "language": this.language,
          "countryCode": this.countrythree,
          "vin": this.vin,
          "userId": this.userId,
          "sessionid": parseInt(this.sessionId),
          "group": this.groupnamereq,
          "section": this.sectionnamereq,
          "component": "",
          "componentSearch": "",
          "pageState": "filterComponent",
          "failureComments": "",
          "labourOnly": "",
          "finisCode": "",
          "filtered": "true",
          "diagnostic": "true"
        }
        this.service.getComponentList(req).subscribe((data) => {
            this.disabledcomponent = false;
            let toFetchSectionData = [];
            toFetchSectionData = Object.values(data.componentList)
            this.componentSearch = toFetchSectionData;
            this.compid = Object.keys(data.componentList)
            this.componentSearch.push(this.translate.instant('Other not on list'))
            this.compid.push('0')
          },
          (err) => {
            /* if we get the response as error */
            this.componentName = "default"
            this.disabledcomponent = true
            this.disabledselectbutton = true
          })
        if (this.sectionNameRecieved == "flagsection" || this.sectionName == "flagsection") {
          this.componentName = "flagsection";
          this.compid = "0";
          this.componentId = "0";
          this.disabledselectbutton = false;
          this.allComponentName = '';
        }
        if (this.componentName == "default") {
          this.disabledselectbutton = true;
        } else {
          this.disabledselectbutton = false;
        }
      }
    }
    if (this.allComponentName) {
      this.disabledselectbutton = false;
    }
  }

  /*to select component*/
  onSelectComponent(setCompname: any) {
    this.isDSSHRestrictedModule=false;
    let index1 = this.componentSearch.findIndex((data: any) => {
      return data == setCompname
    })

    if (index1 + 1 == this.componentSearch.length) {
      this.componentOthers = true;
      this.isComponentSearchDisabled = false;
    } else {
      if ((setCompname != 'default') || (this.groupName != 'default' && this.selectedSectionName != 'default' && setCompname == 'default')) {
        this.isComponentSearchDisabled = true;
      } else {
        this.isComponentSearchDisabled = false;
      }
      this.componentOthers = false;
    }
    console.log('component others:', this.componentOthers);

    this.disabledselectbutton = true;
    if (this.componentName == "flagsection") {
      this.allComponentName = '';
      this.disabledselectbutton = false;
    } else {
      this.componentName = setCompname;
      this.index = this.componentSearch.findIndex((data: any) => {
        return data == setCompname
      })
      this.componentId = this.compid[this.index]
      this.allComponentName = '';
      this.disabledselectbutton = false;
      // if (this.componentName == "flagsection" || this.componentName == (this.translate.instant('Other not on list'))) {
      //   this.onList = true;
      // }
      // else {
      //   this.onList = false;
      // }
      if (setCompname.length > 0) {
        this.disabledselectbutton = false;
      }
    }
    if (this.componentName == "default") {
      this.disabledselectbutton = true;
    } else {
      this.disabledselectbutton = false;
      if (setCompname !== "default" && setCompname !== "flagsection") {
        const vinReq = {
          vin: this.vin,
          paCode: this.tokenObj.dealerCode,
          country: this.tokenObj.countryThree,
          language: this.tokenObj.language
        };

        this.service.getVindetails(vinReq).subscribe(
          (data) => {
            this.vindetails = data;
            const modelYear = this.vindetails?.modelYear;
            const vehicleDesc = this.vindetails?.vehicleLineDescription;
            const warrantyStartDate = this.vindetails?.warrantyStartDate;
            const warrantyEndDate = this.vindetails?.warrantyEndDate;
            const defaultDisplayName = this.vindetails?.defaultDisplayName;
            const marketName = this.vindetails?.marketName;
            const commonName = this.vindetails?.commonName;

            if (modelYear && vehicleDesc && warrantyStartDate && this.countrythree=='GBR') {
              const req = {
                moduleName: this.allComponentName || setCompname,
                modelYear: modelYear,
                vehicleDesc: vehicleDesc,
                warrantyStartDate: warrantyStartDate,
                warrantyEndDate: warrantyEndDate,
                defaultDisplayName: defaultDisplayName,
                marketName: marketName,
                commonName: commonName
              };
              console.log("Payload", req);
              this.service.getDSSHRestrictedModule(req).subscribe(
                (res: any) => {
                  console.log("entire data--->", res);
                  if (res.status === "RESTRICTED MODULE") {
                    this.edit = this.allComponentName || setCompname;
                    console.log("status------", res.status);
                    this.isDSSHRestrictedModule = true;
                  } else {
                    this.isDSSHRestrictedModule = false;
                  }
                },
                (_error) => {
                  this.isDSSHRestrictedModule = false;
                }
              );
            } else {
              console.log("No model year and description for the vin");
            }
          },
          (error) => {
            console.error("Error fetching VIN details:", error);
            this.isDSSHRestrictedModule = false;
          }
        );
      }
    }
  }

  /* to get data in hidden droplist*/
  onSelectAllComponent(setAllCompname: any) {
    this.allComponentName = setAllCompname;
    if (setAllCompname.length > 0) {
      this.disabledselectbutton = false;
      this.allComponentName = setAllCompname;
      this.showSuggest = false;
      this.indexall = this.componentSearchAll.findIndex((data: any) => {
        return data == setAllCompname
      })
      this.componentAllId = this.allSearchId[this.indexall]
      const vinReq = {
        "vin": this.vin,
        "paCode": this.tokenObj.dealerCode,
        "country": this.tokenObj.countryThree,
        "language": this.tokenObj.language
      }
      this.service.getVindetails(vinReq).subscribe(
        (data) => {
          this.vindetails = data
          const modelYear = this.vindetails?.modelYear;
          const vehicleDesc = this.vindetails?.vehicleLineDescription;
          const warrantyStartDate = this.vindetails?.warrantyStartDate;
          const warrantyEndDate = this.vindetails?.warrantyEndDate;
          const defaultDisplayName = this.vindetails?.defaultDisplayName;
          const marketName = this.vindetails?.marketName;
          const commonName = this.vindetails?.commonName;
          if (modelYear && vehicleDesc && warrantyStartDate && this.countrythree=='GBR') {
            const req = {
                moduleName: this.allComponentName,
                modelYear: modelYear,
                vehicleDesc: vehicleDesc,
                warrantyStartDate: warrantyStartDate,
                warrantyEndDate: warrantyEndDate,
                defaultDisplayName:defaultDisplayName,
                marketName:marketName,
                commonName:commonName
            };
            console.log("Payload",req);
            this.service.getDSSHRestrictedModule(req).subscribe((data : any) => {
              console.log("entire data--->",data);
              if(data.status == "RESTRICTED MODULE"){
                this.edit=this.allComponentName
                console.log("status------",data.status)
                this.isDSSHRestrictedModule = true;
              }
              else{
                this.isDSSHRestrictedModule= false;
              }
              },(_error)=>{
                this.isDSSHRestrictedModule= false;
              });
          }
          else{
              console.log("No model year and description for the vin")
          }
      });
    }
  }

  /*to update component search input field*/
  updateList() {
    this.allComponentSearch = []
    if (this.allComponentName.length > 0) {
      this.disabledselectbutton = true;
      for (let i in this.componentSearchAll) {
        if (this.componentSearchAll[i].toLowerCase().includes(this.allComponentName.toLowerCase())) {
          this.allComponentSearch.push(this.componentSearchAll[i])
        }
      }
      this.allComponentSearch = this.allComponentSearch.filter((element: any, i: any) =>
        i === this.allComponentSearch.indexOf(element))
      if (this.allComponentSearch.length == 0 && this.disabledSection && this.disabledcomponent) {
        this.showSuggest = false;
        this.disabledselectbutton = true;
      } else {
        this.showSuggest = true;
      }
    } else {
      this.showSuggest = false;
      this.disabledselectbutton = true;
      this.componentAllId = "";
      if ((!this.disabledSection && !this.disabledcomponent && this.componentName !== 'default') || (this.groupName !== 'default')) {
        this.disabledselectbutton = false;
      }
      this.allComponentSearch = [];
    }
  }

  /*on click of select button*/
  onselect() {

    this.errorMessage = '';
    this.errorMsg = '';
    if (this.groupName == (this.translate.instant('Other not on list'))) { this.groupnamereq = "0" } else { this.groupnamereq = this.groupName }
    if (this.sectionNameRecieved == "flagsection") { this.sectionnamereq = "0" } else { this.sectionnamereq = this.sectionNameRecieved }
    if (this.componentId == undefined) { this.compnamereq = "0" } else { this.compnamereq = this.componentId }
    if (this.componentAllId == undefined) { this.componentAllId = "" }
    let req = {
      "userType": this.userType,
      "language": this.language,
      "countryCode": this.countrythree,
      "vin": this.vin,
      "userId": this.userId,
      "sessionid": parseInt(this.sessionId),
      "group": this.groupnamereq,
      "section": this.sectionnamereq,
      "component": this.compnamereq,
      "componentSearch": this.componentAllId,
      "pageState": "componentSelected",
      "failureComments": "",
      "labourOnly": "",
      "finisCode": "",
      "filtered": "true",
      "diagnostic": "true"
    }
    this.service.getSelectedList(req).subscribe((data) => {
      console.log("RESTRICTED MODULE:::::::::::::::",this.isDSSHRestrictedModule);
      if(this.isDSSHRestrictedModule){
        this.modalService.open(this.data, {size: 'md'});
       // this.firstPage=false;
        return;
      }
      else{
        if (this.componentName.length != '' && this.allComponentName.length != '') {
          this.edit = this.allComponentName;
        }
        else if (this.componentName.length != '' && this.allComponentName.length == '') {
          this.edit = this.componentName;
          if (this.componentName == "flagsection") {
            this.edit = (this.translate.instant('Other not on list'));
          }
        }
        else {
          this.edit = this.allComponentName;
        }
        if (this.componentName == 'flagsection' || this.componentName == (this.translate.instant('Other not on list'))) {
          if (this.allComponentName.length != '') {
            this.onList = false;
          }
          else {
            this.onList = true;
          }
        }
        else {
          this.onList = false;

        }
        this.firstPage = false;
        this.disabledcomponent = false;
     }
    },
      (err) => {
        /* if we get the response as error */

      })
  }
  /* to check the finis code and checkbox*/
  onFinis() {
    if (this.finis == '') {
      this.disableLabor = false;
      if (this.groupnamereq == "0" && this.sectionnamereq == "0" && this.compnamereq == "0") {
        this.isConfirBtnVisuallyDisabled = true;
      }
    } else {
      this.disableLabor = true;
      if (this.groupnamereq == "0" && this.sectionnamereq == "0" && this.compnamereq == "0") {
        if (this.causeRepair.length >= 5 && this.finis.length == 7) {
          this.isConfirBtnVisuallyDisabled = false;
        } else if (this.causeRepair.length >= 5 && this.finis.length < 7) {
          this.isConfirBtnVisuallyDisabled = true;
        }
      }
    }
  }

  /* to check the labor only checkbox*/
  laborCheck() {
    if (this.isChecked == true) {
      this.finis = '';
      this.disableCheckFinis = true;
      if (this.groupnamereq == "0" && this.sectionnamereq == "0" && this.compnamereq == "0") {
        if (this.causeRepair.length >= 5) {
          this.isConfirBtnVisuallyDisabled = false;
        }
      }
    } else {
      this.disableCheckFinis = false;
      if (this.groupnamereq == "0" && this.sectionnamereq == "0" && this.compnamereq == "0") {
        this.isConfirBtnVisuallyDisabled = true;
      }
    }
  }

  /*to check the length of teh data given in text area*/
  checkLength() {
    this.myText = document.getElementById("failureComments");
    this.myText.addEventListener("keyup", () => {
      var characters = this.myText.value.split('');
      this.count = 2000 - characters.length;
      if (this.causeRepair.length >= 5) {
        if (this.groupnamereq == "0" && this.sectionnamereq == "0" && this.compnamereq == "0") {
          if (this.finis.length == 7 || this.isChecked == true) {
            this.isConfirBtnVisuallyDisabled = false;
          }
        } else {
          this.isConfirBtnVisuallyDisabled = false;
        }
      } else {
        this.isConfirBtnVisuallyDisabled = true;
      }
    });
    this.numcolor = this.count;
    if (this.numcolor > 0) {
      this.colorflag = false;
      this.lengthofcommenterror = '';
    } else {
      this.colorflag = true;
    }
  }

  /*on click of edit*/
  onEdit() {
    this.firstPage = !this.firstPage
    this.allComponentSearch = [];
    this.isConfirBtnVisuallyDisabled = false;
  }

  // Extract ID from the string
  extractNumbers(str: string) {
    const match = str.match(/(\d+)(?:-(\d+))?/); // Matches one or more digits, optionally followed by a hyphen and more digits

    if (match) {
      const id1 = parseInt(match[1], 10);
      const id2 = match[2] ? parseInt(match[2], 10) : null;
      return {id1, id2};
    } else {
      return {id1: null, id2: null};
    }
  }

  /* on click of confirm*/

  confirm() {
    if (this.groupName == (this.translate.instant('Other not on list'))) {
      this.groupnamereq = "0"
    } else {
      this.groupnamereq = this.groupName
    }
    if (this.sectionNameRecieved == "flagsection") {
      this.sectionnamereq = "0"
    } else {
      this.sectionnamereq = this.sectionNameRecieved
    }
    if (this.onList == false) {
      this.finis = ""
    }
    if (this.componentId == undefined) {
      this.compnamereq = "0"
    } else {
      this.compnamereq = this.componentId
    }
    if (this.componentAllId == undefined) {
      this.componentAllId = ""
    }
    console.log("Identify Failure Component - Confirm Btn Click(session id)", this.sessionId);
    console.log("Gp*", this.groupnamereq, "sec*", this.sectionnamereq, "comp*", this.compnamereq, "Allcomp*", this.componentAllId);
    let logReq = {
      "requestType": "LOGMessage",
      "languageCode": this.language,
      "countryCode": this.countrythree,
      "symptoms": "Btnconfirm-gp-" + this.selectedGroupID.id1 + "-Sec-" + this.selectedSectionID.id1 + "-" + this.selectedSectionID.id2 + "-comp-" + this.compnamereq + "-MCompSrch--" + this.componentAllId + "-List-" + this.onList + "-SId-" + this.sessionId,
      "vehicleModel": this.vin + "gp-" + this.groupOthers + "sec-" + this.sectionOthers + "comp-" + this.componentOthers,
      "username": this.username
    }
    this.service.insertTargetEngineTestDetails(logReq).subscribe();

    let req = {
      "userId": this.userId,
      "sessionid": parseInt(this.sessionId),
      "group": this.groupnamereq,
      "section": this.sectionnamereq,
      "component": this.compnamereq,
      "componentSearch": this.componentAllId,
      "pageState": "confirm",
      "failureComments": this.causeRepair,
      "labourOnly": this.isChecked,
      "finisCode": this.finis,
      "filtered": "true",
      "diagnostic": "true"
    }
    for (let i of ['2222222', '3333333', '4444444', '5555555', '6666666', '7777777', '8888888', '0000000']) {
      if (i == this.finis) {
        this.finisCodeVerify = true;
      }
    }
    if (this.onList == true && this.groupnamereq == "0") {
      console.log("Onlist----", this.onList, "groupname-----", this.groupnamereq);
      if (this.isChecked == false) {
        if (/^[0-9]+$/.test(this.finis) && this.finis.length == 7 && this.finisCodeVerify == false) {
          if (this.causeRepair == null || this.causeRepair == undefined || this.causeRepair == '' && this.causeRepair.length < 5) {
            this.errorMessage = this.translate.instant('fault_description_msg');
            this.errorMsg = '';
          } else {
            if (this.colorflag) {
              this.errorMessage = "You have entered more than the maximum number of characters (2000).";
              this.errorMsg = '';
            } else {
              this.errorMessage = '';
              this.errorMsg = '';
              // navigate to next pagep
              this.showSpinner = true;
              this.spinnerService.show();
              this.service.getConfirmstatusInIdentifyFailure(req).subscribe((data) => {
                this.spinnerService.hide();
                this.showSpinner = false;
                this.secondPage = false;
                this.modalService.open(this.noRVCMsgInfo, {size: 'md'});
                this.disableButtonAfterModalOpen();
              }, (error) => {
                this.spinnerService.hide();
              });
            }
          }
        } else if (this.causeRepair == null || this.causeRepair == undefined || this.causeRepair == '' || this.causeRepair.length < 5) {
          this.errorMsg = this.translate.instant('fault_description_msg');
          this.finisCodeVerify = false;
          this.modalService.open(this.faultMsgInfo, {size: 'md'});
        } else if (this.isChecked == false && this.finis == '') {
          this.errorMsg = '';
          this.errorMessage = '';
          this.modalService.open(this.faultMsgInfo, {size: 'md'});
        } else if (this.finis.length < 7) {
          this.errorMsg = '';
          this.errorMessage = this.translate.instant('Identify failure component error2')
        } else {
          this.errorMsg = '';
          this.finisCodeVerify = false;
          if (this.colorflag) {
            this.errorMessage = "You have entered more than the maximum number of characters (2000).";
            this.errorMsg = '';
          }
        }
      } else {
        if (this.causeRepair == null || this.causeRepair == undefined || this.causeRepair == '') {
          //this.errorMessage = this.translate.instant('You must enter cause and repair details')
          this.errorMessage = this.translate.instant('fault_description_msg');
          this.errorMsg = '';
        } else {
          if (this.colorflag) {
            this.errorMessage = "You have entered more than the maximum number of characters (2000).";
            this.errorMsg = '';
          } else {
            this.errorMessage = '';
            this.errorMsg = '';
            // navigate to next page
            if (this.causeRepair.length >= 5) {
              this.showSpinner = true;
              this.spinnerService.show();
              this.service.getConfirmstatusInIdentifyFailure(req).subscribe((data) => {
                this.spinnerService.hide();
                this.showSpinner = false;
                this.secondPage = false;
                this.modalService.open(this.noRVCMsgInfo, {size: 'md'});
                this.disableButtonAfterModalOpen();
              }, (error) => {
                this.spinnerService.hide();
              });
            } else {
              this.errorMessage = this.translate.instant('fault_description_msg');
              this.errorMsg = '';
            }
          }
        }
      }
    } else {
      if (this.causeRepair == null || this.causeRepair == undefined || this.causeRepair == '' || this.causeRepair.length < 5) {
        this.errorMessage = this.translate.instant('fault_description_msg');
        this.errorMsg = '';
      } else if (this.finis.length >= 1 && this.finis.length < 7) {
        this.errorMessage = this.translate.instant('Identify failure component error2')
        this.errorMsg = '';
      } else {
        if (this.colorflag) {
          this.errorMessage = this.translate.instant('fault_description_limit') + "2000.";
          this.errorMsg = '';
        } else {
          this.errorMessage = '';
          this.errorMsg = '';
          this.showSpinner = true;
          this.spinnerService.show();
            // Not DSSH restricted, proceed with the old logic based on onList
            console.log("Confirm clicked. Not DSSH restricted. Checking onList value.");
            if (this.onList == true) {
              console.log("Confirm clicked. Not DSSH restricted AND onList=true. Showing 'No RVC Required' message.");
              this.service.getConfirmstatusInIdentifyFailure(req).subscribe((data) => {
                this.spinnerService.hide();
                this.showSpinner = false;
                this.secondPage = false; // Hide the edit page content
                this.modalService.open(this.noRVCMsgInfo, {size: 'md'});
                this.disableButtonAfterModalOpen();
              }, (error) => {
                this.spinnerService.hide();
                console.error("Error confirming failure details for No RVC Required path", error);
              });
            } else {
              console.log("Confirm clicked. Not DSSH restricted AND onList=false. Navigating to Warranty page.");
              this.service.getConfirmstatusInIdentifyFailure(req).subscribe((data) => {
                let logReq = {
                  "requestType": "LOGMessage",
                  "languageCode": this.language,
                  "countryCode": this.countrythree,
                  "symptoms": "BtnConfirm-NOT-OTHERSNOTONLIST-NAVIGATIONTOWARRANTYDEALERSCREEN",
                  "vehicleModel": this.vin,
                  "username": this.username
                }
                this.service.insertTargetEngineTestDetails(logReq).subscribe();
                if(this.isDSSHRestrictedModule){
                  const deleteRvcReq = {
                    rvcCode: this.rvcCode,
                    dealerCode: this.tokenObj.dealerCode,
                    sessionId: this.sessionId
                  };
                  this.service.deleteRvc(deleteRvcReq).subscribe((deleteResponse) => {
                    console.log("RVC deleted successfully:", deleteResponse);
                    this.spinnerService.hide();
                    this.showSpinner = false;
                  //  this.router.navigateByUrl('/repair');
                  }, (deleteError) => {
                    console.error("Error deleting RVC:", deleteError);
                    this.spinnerService.hide();
                  });
                  this.showRvcInput = false;
                  let req = {
                    "sessionId": this.sessionId,
                    "dealerCode": this.dealerCode,
                    "isCustomerPaid": false,
                    "isDSSHRestricted": this.isDSSHRestrictedModule,
                    "rvcCode": this.rvcCode
                  }
                  this.service.getRepairPostRepairDetails(req).subscribe((data) => {
                    this.service.repairQualificationData.next(data);
                    this.spinnerService.hide();
                    this.showSpinner = false;
                    this.router.navigateByUrl('/repair');
                  }, (error) =>{
                    console.error("ERROR IN GET REPAIR QUALIFICATION", error);
                  });
                }else{
                  this.spinnerService.hide();
                  this.showSpinner = false;
                  this.router.navigateByUrl('/warrantyDealerCode')
                }
              }, (error) => {
                this.spinnerService.hide();
                console.error("Error confirming failure details before warranty navigation", error);
                // Handle API error here if needed, maybe show an error and don't navigate?
              });
            }
          }
          // navigate to next page
          // if (this.onList == true) {
          //   console.log("when others not on list show complete session page(onlist value)", this.onList)
          //   let logReq = {
          //     "requestType": "LOGMessage",
          //     "languageCode": this.language,
          //     "countryCode": this.countrythree,
          //     "symptoms": "BtnConfirm-OTHERSNOTONLIST-COMPLETESESSIONBTN",
          //     "vehicleModel": this.vin,
          //     "username": this.username
          //   }
          //   this.service.insertTargetEngineTestDetails(logReq).subscribe();
          //
          //   this.service.getConfirmstatusInIdentifyFailure(req).subscribe((data) => {
          //     this.spinnerService.hide();
          //     this.showSpinner = false;
          //     this.secondPage = false;
          //     this.modalService.open(this.noRVCMsgInfo, {size: 'md'});
          //     this.disableButtonAfterModalOpen();
          //   }, (error) => {
          //     this.spinnerService.hide();
          //   });
          // } else {
          //
          //   this.service.getConfirmstatusInIdentifyFailure(req).subscribe((data) => {
          //     console.log("Navigate to Warranty page ----------", this.onList)
          //     let logReq = {
          //       "requestType": "LOGMessage",
          //       "languageCode": this.language,
          //       "countryCode": this.countrythree,
          //       "symptoms": "BtnConfirm-NOT-OTHERSNOTONLIST-NAVIGATIONTOWARRANTYDEALERSCREEN",
          //       "vehicleModel": this.vin,
          //       "username": this.username
          //     }
          //     this.service.insertTargetEngineTestDetails(logReq).subscribe();
          //
          //     this.spinnerService.hide();
          //     this.showSpinner = false;
          //     this.router.navigateByUrl('/warrantyDealerCode')
          //   }, (error) => {
          //     this.spinnerService.hide();
          //   });
          // }
      }
    }
  }

  disableButtonAfterModalOpen() {
    setTimeout(() => {
      this.isButtonEnabled = false;
    }, 3000);
  }

  gcrSubmit() {
    const newWindow = window.open('https://www.gcr.dealerconnection.com/asp/FordDealerMenu.asp?vin=' + this.vin + '&appname=PTS', '_blank', 'width=700,height=700');
  }

  restartDiagnostics() {
    this.service.repairCompleteBtnClick(this.sessionId).subscribe((data) => {
      localStorage.setItem("component", "fromNetworkTest");
      this.service.navigatePreviousScreen.next('');
      this.router.navigate(['/closeCanceldiagnosis'])
    })

  }

  continueRequest(data: any) {
    const newWindow = window.open(this.service.gtacUrl + 'LANG=' + this.language + '-US&Contactid=&vin=' + this.vin  + '&USERID=' + this.username + '&Symptom_codes=12&GEO=' + this.countrythree + '&PACODE=' + this.dealerCode + '&countryCode=' + this.countrythree + '&Model=' + this.vehicle + '&Year=' + this.modelYear, '_blank', 'width=700,height=700');

    // console.log(`Attempting to navigate to route '/rvc'`);
    // console.log(`Executing navigation to route '/rvc'.`); // Log inside setTimeout
    // this.router.navigateByUrl('/rvc');
      this.firstPage = false; // Hide the initial form
      this.showRvcInput = true;
      if(this.showRvcInput){
        const req = {
          "sessionId": localStorage.getItem("sessionID"),
          "pageid": "25"
        }
        this.service.updatePage(req).subscribe(data => { })

      }
    this.modalService.dismissAll();
  }

  contactDssh(){
    this.modalService.open(this.data, {size: 'md'});
    this.firstPage=false;
  }

    validateRvcCode(): void {
        this.validationError = '';
        if (!this.rvcCode) {
            this.validationError = this.translate.instant('RVC code is required.'); // Use translation service
            console.warn('Validation failed: RVC code is empty.');
            return; // Stop the method execution
        }
        if (this.rvcCode.length !== 13) {
            this.validationError = this.translate.instant('RVC code must be 13 characters long.'); // Use translation service
            console.warn('Validation failed: Incorrect length.');
            return;
        }
        this.sessionId=localStorage.getItem("sessionID")
      //modified payload
        const req1 ={
            rvcCode: this.rvcCode,
            dealerCode: this.tokenObj.dealerCode,
            sessionId:this.sessionId
        }
        this.service.validateRvcCode(req1).subscribe((data : any) => {
            if(data.status == "Valid"){
                this.showRvcInput = false;
            }else{
                this.modalService.open(this.InvalidRvcTemplate, { size: 'md' });
            }
        });

    }

    pauseSession() {
        console.log('Pause Session clicked');
        // Set a flag in localStorage to indicate the session was paused on the RVC page
        localStorage.setItem('pausedOnRvcPage', 'true');
        localStorage.setItem("component", "fromNetworkTest")
        this.service.navigatePreviousScreen.next('');
        this.router.navigate(['/closeCanceldiagnosis'])
    }

    endSession() {
        this.sessionId = localStorage.getItem("sessionID"); // Retrieve session ID from localStorage
        this.service.cancelBtnClick(this.sessionId).subscribe((data) => {
            console.log("close btn click:", data);
            localStorage.removeItem('pausedOnRvcPage');
            localStorage.setItem("component", "fromNetworkTest") ;
            localStorage.removeItem('sessionID');
            this.router.navigate(['/closeCanceldiagnosis']);
        })
    }

     downloadPageAsPdf(): void {
  const element: HTMLElement = document.body;

  const opt: any = {
    margin: [12, 12, 12, 12],
    filename: 'Page-Report.pdf',
    image: { type: 'jpeg', quality: 0.95 },
    html2canvas: { scale: 1.25, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  // html2pdf loaded via CDN
  // @ts-ignore
  if (typeof html2pdf !== 'undefined') {
    // @ts-ignore
    html2pdf().from(element).set(opt).save();
  } else {
    window.print();
  }
}

printPageNative(): void {
  window.print();
}

}
